<template>
  <q-page class="column">
    <iframe :src="publicComponentSrc" style="width: 100%; height: 100%;" class="col" frameBorder="0"></iframe>
  </q-page>
</template>

<script>

export default {
  data () {
    return {}
  },
  components: {
  },
  computed: {
    publicComponentSrc () {
      // return 'https://public.submind.io/components/' + this.$route.params.id
      return (process.env.PUBLIC_URL || 'https://public.submind.io') + '/components/' + this.$route.params.id
    }
  }
}
</script>

<style lang="styl">
</style>
